import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import AdminSidebar from './AdminSidebar'

function formatNow() {
  return new Date().toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

function AdminTopbarAvatar({ user, danger }) {
  const initials = user?.real_name?.charAt(0) || user?.system_name?.charAt(0) || 'A'
  const className = `admin-topbar-avatar${danger ? ' danger' : ''}`
  if (user?.avatar_url) {
    return (
      <Link to="/admin/profile" className={className} title="My Profile" style={{ padding: 0, overflow: 'hidden' }}>
        <img src={user.avatar_url} alt="" className="admin-topbar-avatar-img" />
      </Link>
    )
  }
  return (
    <Link to="/admin/profile" className={className} title="My Profile">
      {initials.toUpperCase()}
    </Link>
  )
}

export default function AdminLayout({
  variant = 'inner',
  title,
  subtitle,
  flush = false,
  bare = false,
  dangerTopbar = false,
  children,
}) {
  const { user } = useAuth()

  if (variant === 'dashboard') {
    return (
      <div className="admin-shell admin-layout">
        <AdminSidebar />
        <div className="admin-dashboard-main">
          <div className="admin-top-bar">
            <h1 className="admin-page-title">{title || 'Platform Dashboard'}</h1>
            <div className="admin-topbar-right">
              <span>Last updated: Just now</span>
              <AdminTopbarAvatar user={user} />
            </div>
          </div>
          {children}
        </div>
      </div>
    )
  }

  return (
    <div className={`admin-shell admin-layout${bare ? ' admin-layout-bare' : ''}`}>
      <AdminSidebar />
      <div className="admin-main">
        {!bare && (
          <div className="admin-topbar">
          <div className="admin-topbar-left">
            <AdminTopbarAvatar user={user} danger={dangerTopbar} />
            <div>
              <div style={{ fontSize: 13, fontWeight: 600 }}>Admin</div>
              <div style={{ fontSize: 11, color: 'var(--admin-text-muted)' }}>
                {subtitle || 'Platform Administrator'}
              </div>
            </div>
          </div>
          <div className="admin-topbar-right">{formatNow()}</div>
        </div>
        )}
        <div className={`admin-page-content${flush ? ' flush' : ''}`}>
          {children}
        </div>
      </div>
    </div>
  )
}
